import * as React from 'react'
import styled from 'styled-components'
import Icon from '../../../components/Icons/Icon'
import { CSSTransition } from 'react-transition-group'


const Container = styled.div`
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
  position: fixed;
  z-index: 2147483003;
  background: rgba(20, 22, 26, 0.35);
  inset: 0;
  outline-offset: 5px;
  opacity: 0;
  transition: opacity 200ms;

  &.enter-done {
    opacity: 1;
  }
`

const Wrapper = styled.div`
  height: 100%;
  width: 100%;
  position: relative;
`

const Background = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
`

const Close = styled.div`
  width: 19px;
  height: 19px;
  position: absolute;
  top: 30px;
  right: 40px;
  background-repeat: no-repeat;
  cursor: pointer;

  svg {
    width: 19px;
    height: 19px;
    fill: white;
    color: white;
    opacity: 0.7;
  }
`

const ImageContainer = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
  cursor: zoom-out;

  img {
    cursor: zoom-out;
    max-width: 90vw;
    max-height: 90vh;
    transition: max-width 200ms, max-height 200ms;
    opacity: 0;
    transform: translateY(20px);

    .enter-done & {
      opacity: 1;
      transform: translateY(0px);
      transition: opacity 200ms, transform 200ms;
    }
  }
`

interface IProps {
  url: string
  onClose: () => void
}

const PreviewModal = (props: IProps) => {
  const { url } = props

  const onClose = (e) => {
    e.preventDefault()
    e.stopPropagation()

    props.onClose()
  }

  return (
    <CSSTransition
      in={Boolean(url)}
      timeout={250}
      unmountOnExit
    >
      <Container>
        <Wrapper>
          <Background onClick={onClose} />
          <Close onClick={onClose}>
            <Icon icon='messenger-close' />
          </Close>

          <ImageContainer onClick={onClose}>
            <img src={url} />
          </ImageContainer>
        </Wrapper>
      </Container>
    </CSSTransition>
  )
}

export default PreviewModal